import { mapBillStatusFromDTO } from '@/modules/common/mappers/bill-status.mapper';
import { BillListItem } from '@/modules/finance/bills/types/bills';
import { BillSummaryResponse } from '@/modules/finance/bills/types/dto/response/bill-summary.response';
import { formatDateRange } from '@/utils/date-formatters';

import { mapBillSyncErrorFromResponse } from './bill-sync.mapper';

/**
 * Maps BillSummaryResponse from API to domain BillListItem
 */
export const mapBillSummaryFromResponse = (response: BillSummaryResponse): BillListItem => {
  const datePeriod =
    !response.startDate || !response.endDate
      ? ''
      : formatDateRange(response.startDate, response.endDate);

  return {
    id: response.id,
    number: response.referenceNumber,
    externalId: response.externalId,
    member: {
      id: response.forUser.id,
      email: response.forUser.email,
      name: response.forUser.name,
      profileImageUrl: response.forUser.profileImageUrl,
      isDeleted: response.forUser.isDeleted,
    },
    status: mapBillStatusFromDTO(response.status),
    createdOn: response.endDate ? new Date(response.endDate) : new Date(response.createdAt),
    dueDate: new Date(response.dueDate),
    period: datePeriod,
    balance: response.balance,
    amount: response.totalAmount,
    currencyCode: response.currency.code,
    syncError: mapBillSyncErrorFromResponse(response.syncError),
  };
};

/**
 * Maps array of BillSummaryResponse to array of BillListItem
 */
export const mapBillSummariesFromResponse = (responses: BillSummaryResponse[]): BillListItem[] => {
  return responses.map(mapBillSummaryFromResponse);
};
